import SectionHeading from '@/components/feature/SectionHeading';

const steps = [
  {
    icon: 'ri-search-eye-line',
    title: '先确定想看的类型',
    desc: '在频道分类里挑一个大方向，或直接用推荐区的频道标签，把范围收窄到几十部以内。',
  },
  {
    icon: 'ri-file-list-3-line',
    title: '看简介再决定',
    desc: '每条推荐都有一段剧情简介与看点标签，先读简介，避免被标题和封面误导。',
  },
  {
    icon: 'ri-bookmark-line',
    title: '加入追番清单',
    desc: '把犹豫的条目先收进清单，之后在清单区集中比较，选出最想先看的那一部。',
  },
  {
    icon: 'ri-calendar-schedule-line',
    title: '对照时间表安排',
    desc: '追更连载看时间表按天观看，已完结作品则整季规划，保持稳定的观看节奏。',
  },
];

export default function GuideSection() {
  return (
    <section id="guide" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="观看与筛选指南"
          title="四步用好这个页面"
          desc="从挑选到排期，本页面的筛选、清单与时间表功能可以配合使用。按下面的顺序操作，通常能更快找到真正想看的作品。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {steps.map((s, i) => (
            <article key={s.title} className="relative rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
              <span className="absolute top-4 right-5 font-heading text-3xl md:text-4xl text-background-300">
                0{i + 1}
              </span>
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-900 text-2xl">
                <i className={s.icon}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}